import { Action, action, computed, Computed } from 'easy-peasy'
import { MortgageEstimate } from '@mortgage-pos/types'
import { StoreModel } from './index'

export interface BankrateCompareModel {
  mortgageRateEstimate: MortgageEstimate
  currentMortgageDetails: Computed<
    BankrateCompareModel,
    MortgageEstimate,
    StoreModel
  >
  setMortgageRateEstimate: Action<BankrateCompareModel, MortgageEstimate>
}

const bankrateCompare = (): BankrateCompareModel => {
  return {
    mortgageRateEstimate: null,

    setMortgageRateEstimate: action((state, payload) => {
      state.mortgageRateEstimate = payload
    }),

    currentMortgageDetails: computed(
      [
        (_, storeState) => storeState.answers.mergedAnswers,
        (_, storeState) => storeState.bankrateCompare.mortgageRateEstimate,
      ],
      (mergedAnswers, mortgageRateEstimate) => {
        const currentMortgageDetails: MortgageEstimate = {
          paymentDueAmount:
            mergedAnswers.leRate?.[0]?.principleAndInterestPayment ||
            mergedAnswers?.monthlyPayment ||
            mortgageRateEstimate?.paymentDueAmount,
          estimatedInterestRate:
            mergedAnswers.leRate?.[0]?.rate ||
            mortgageRateEstimate?.estimatedInterestRate,
          openedDate:
            mergedAnswers.currentLoanStartDate ||
            mortgageRateEstimate?.openedDate,
          paymentScheduleMonthCount:
            parseInt(mergedAnswers.leRate?.[0]?.term?.substring(1)) * 12 ||
            mergedAnswers.currentLoanTerm * 12 ||
            mortgageRateEstimate?.paymentScheduleMonthCount,
          currentBalance:
            mergedAnswers.remainingBalance ||
            mortgageRateEstimate?.currentBalance,
        }

        return currentMortgageDetails
      }
    ),
  }
}

export default bankrateCompare
